import useMobile from '../../../../other/Hooks/useMobile'
import useOrientation from '../../../../other/Hooks/useOrientation'
import MobileLandscapeMap from './Mobile/Landscape/Map'
import MobilePortraitMap from './Mobile/Portrait/Map'
import DesktopMap from './Desktop/Map'
type Props = {
    setLocation: (arg0: string | null) => void
    setHeading: any
    setHotspotPosition: any
    selectedLocation: string | null
}
export default function Map({ setLocation, setHeading, selectedLocation, setHotspotPosition }: Props) {
    const isMobile = useMobile()
    const isLandscape = useOrientation()


    if (isMobile && isLandscape) return <MobileLandscapeMap setLocation={setLocation} selectedLocation={selectedLocation} />
    else if (isMobile && !isLandscape) return <MobilePortraitMap setLocation={setLocation} selectedLocation={selectedLocation} />

    else return <DesktopMap
        setHeading={setHeading}
        setHotspotPosition={setHotspotPosition}
        setLocation={setLocation}
        selectedLocation={selectedLocation}
    />
}
